function getMessage(field, [min]) {
  return `The ${field} field must be ${min} or more characters.`
}

function validate(value, [min]) {
  return (value !== null && value !== undefined && value.length >= min)
}

export default {
  getMessage,
  validate
}
